import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom'; // If using React Router
import { getAuth, applyActionCode } from 'firebase/auth';
import { Box } from '@mui/material';

const AuthAction = () => {
  const auth = getAuth();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode');
  const oobCode = searchParams.get('oobCode');
  const [status, setStatus] = useState("Processing email verification...");

//   useEffect(() => {
//     if (mode === 'verifyEmail' && oobCode) {
//       applyActionCode(auth, oobCode)
//         .then(() => {
//           alert('Email verified successfully!');
//           // Redirect user to login or dashboard
//         })
//         .catch((error) => {
//           console.error('Error verifying email:', error);
//         });
//     }
//   }, [mode, oobCode, auth]);

useEffect(() => {
    if (mode === "verifyEmail" && oobCode) {
      applyActionCode(auth, oobCode)
        .then(() => {
          setStatus("✅ Your email has been verified! You can now log in with your new account.");
        })
        .catch((error) => {
          setStatus("❌ Email verification failed. The link may have expired or already been used.");
          console.error("Error verifying email:", error);
        });
    }
  }, [mode, oobCode, auth]);

  return (
    <Box sx={{ textAlign: "center", padding: "50px", fontFamily:"Montserrat", fontSize:{xs:12, sm:12, md:16, lg:16, xl:16} }}>
      <h2>{status}</h2>
    </Box>
  );
};

export default AuthAction;
